/**
 * Storage keys that belong to the browser rather than to whoever is signed in.
 *
 * These survive a sign-out on purpose. Signing out of an account is not a reason to
 * forget which language this browser reads in, so a key declared here must never end up
 * in `SESSION_STORAGE_KEYS`.
 *
 * That is enforced rather than asked for: `DevicePreferenceKey` and the `SessionOwnedKey`
 * that `shared/lib/token` builds its teardown list from are separate branded types, so
 * adding one of these to that list does not compile.
 *
 * This module deliberately imports nothing. `react-i18next` reads the language at module
 * scope, before React mounts, so anything it pulls in loads on that path too.
 */

declare const devicePreferenceBrand: unique symbol

export type DevicePreferenceKey = string & {
  readonly [devicePreferenceBrand]: true
}

const devicePreference = (key: string) => key as DevicePreferenceKey

/**
 * The language this browser reads in.
 *
 * Written by hand in `shared/lib/react-i18next`, not by a detector plugin --
 * `i18next-browser-languagedetector` is not a dependency. The name matches what that
 * plugin would have used, which is why it looks like a library's key and is not one.
 */
export const LANGUAGE_KEY = devicePreference("i18nextLng")
